import { t, useLanguage } from "@/i18n/LanguageContext";import { motion } from "framer-motion";
import { BadgeCheck, FileText, Download } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Reveal, Eyebrow, DecorativeStripe } from "@/components/Reveal";

export default function Certificazioni() {useLanguage();
  const { content } = useSite();

  return (
    <main data-testid="certificazioni-page">
      <section className="relative bg-[#F8FAFC] pb-16 pt-20 lg:pt-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Eyebrow>{t("Certificazioni")}</Eyebrow>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-bold tracking-tight text-brand-navydeep sm:text-5xl lg:text-6xl" data-testid="certs-title">
            <span className="block overflow-hidden pb-1">
              <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>{t("Qualità, sicurezza e trasparenza certificate")}

              </motion.span>
            </span>
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.7 }}
            className="mt-6 max-w-2xl leading-relaxed text-slate-600">{t("Certificazioni e attestazioni che garantiscono a stazioni appaltanti e committenti il rispetto dei più alti standard di qualità, ambiente, sicurezza e legalità. I documenti originali sono scaricabili direttamente da questa pagina.")}


          </motion.p>
        </div>
        <DecorativeStripe testId="certifications-header-decorative-stripe" />
      </section>

      <section className="bg-white py-16 lg:py-24" data-testid="certs-grid">
        <div className="mx-auto grid max-w-7xl gap-5 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3 lg:px-8">
          {t(content.certifications.map((c, i) =>
          <Reveal key={i} delay={i * 0.06}>
              <div data-testid={`cert-card-${i}`} className="group flex h-full flex-col rounded-2xl border border-slate-200/80 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-lime hover:shadow-lg">
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center self-start rounded-full bg-brand-limelight text-brand-limedark transition-colors duration-300 group-hover:bg-brand-navy group-hover:text-brand-lime">
                  <BadgeCheck className="h-6 w-6" />
                </div>
                <p className="font-display text-2xl font-bold tracking-tight text-brand-navy">{t(c.code)}</p>
                <h3 className="mt-1 text-sm font-semibold uppercase tracking-wide text-slate-700">{t(c.title)}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">{t(c.desc)}</p>
                {t((c.number || c.expiry || c.org) &&
              <div className="mt-5 border-t border-slate-100 pt-4 font-mono text-[10px] uppercase tracking-wider text-slate-400">
                    {t(c.number && <span>{t("N. ")}{t(c.number)}</span>)}
                    {t(c.number && c.expiry && <span> · </span>)}
                    {t(c.expiry && <span>{t("Scad. ")}{t(c.expiry)}</span>)}
                    {t(c.org && <span className="mt-1 block normal-case tracking-normal">{t(c.org)}</span>)}
                    {t(c.org && c.org.includes("Perry Johnson") &&
                <span data-testid={`cert-pjr-logo-${i}`} className="mt-3 inline-flex items-center gap-2 self-start rounded-lg border border-slate-200 bg-white px-2.5 py-1.5">
                        <img src="/partners/perry-johnson.svg" alt={t("Logo Perry Johnson Registrars")} className="h-6 w-6 shrink-0 object-contain" />
                        <span className="font-sans text-[9px] font-bold normal-case leading-tight tracking-wide text-slate-500">{t("Perry Johnson")}<br />{t("Registrars, Inc.")}</span>
                      </span>)
                }
                  </div>)
              }
                {t(c.file &&
              <a
                href={c.file}
                download
                data-testid={`cert-download-${i}`}
                className="mt-5 inline-flex items-center gap-1.5 self-start rounded-full bg-brand-navy px-4 py-2 text-xs font-bold text-white transition-colors duration-300 hover:bg-brand-lime hover:text-brand-navydeep">
                
                    <Download className="h-3.5 w-3.5" />{t(" Scarica certificato")}
              </a>)
              }
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.4}>
            <div className="flex h-full flex-col justify-center rounded-2xl bg-brand-navydeep p-8 text-white">
              <FileText className="mb-5 h-8 w-8 text-brand-lime" />
              <h3 className="font-display text-xl font-bold">{t("Documentazione completa")}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/70">{t("I certificati sono scaricabili dalle schede qui accanto. Per visure, attestazioni aggiornate e documentazione di gara contatta l'ufficio gare dalla pagina Contatti.")}

              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </main>);

}
